var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.703 8.53413L17.4664 0.297413C17.0697 -0.0991377 16.4266 -0.0991377 16.03 0.297413C15.6334 0.694065 15.6334 1.33716 16.03 1.73376L16.3415 2.0452L9.39951 8.9871L4.32946 10.1571C3.96973 10.2402 3.68332 10.5119 3.58156 10.8668C3.47979 11.2217 3.57861 11.6039 3.83968 11.8649L8.26933 16.2946L0.297939 24.2663C-0.0986621 24.6629 -0.0986621 25.306 0.297939 25.7026C0.694541 26.0992 1.33763 26.0992 1.73429 25.7025L9.70567 17.7309L14.1356 22.1608C14.3969 22.4221 14.7791 22.5206 15.1337 22.4188C15.4886 22.3171 15.7603 22.0307 15.8434 21.6709L17.0134 16.6009L23.9552 9.65899L24.2667 9.97043C24.6634 10.3671 25.3064 10.367 25.703 9.97043C26.0996 9.57388 26.0996 8.93079 25.703 8.53413ZM14.2761 19.4287C14.1902 19.3428 6.65753 11.8101 6.57176 11.7243L9.59157 11.0274L14.9731 16.4089L14.2761 19.4287ZM16.0893 14.6525L11.348 9.91122L17.7777 3.48155L22.5189 8.22274L16.0893 14.6525Z",
    fill: "#1873B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.0d7eac849e3c8c63f7394b980c499a03.svg";
export { ForwardRef as ReactComponent };